import { render, staticRenderFns } from "./showBigPhoto.vue?vue&type=template&id=29ff5c5d&scoped=true&"
import script from "./showBigPhoto.vue?vue&type=script&lang=js&"
export * from "./showBigPhoto.vue?vue&type=script&lang=js&"
import style0 from "./showBigPhoto.vue?vue&type=style&index=0&id=29ff5c5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ff5c5d",
  null
  
)

export default component.exports